/** @jsx m */

import ForumApplication from './ForumApplication'
import compat from './compat'

const app = new ForumApplication()
compat.app = app

export { compat, app }
